import { render, staticRenderFns } from "./selectType.vue?vue&type=template&id=422d77ec&scoped=true&"
import script from "./selectType.vue?vue&type=script&lang=js&"
export * from "./selectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d77ec",
  null
  
)

export default component.exports